import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Lottie from 'lottie-react';
import lodash from 'lodash';
import FetchModule from "../../../Model/Share/Network/FetchModule";
import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { formatPhoneNumber } from '../../../Utils/phoneUtils';

import ContentInput from "../Model/ContentInput";
import NotRegistrationCardModal from '../../../Model/Share/Normal/NotRegistrationCardModal';
import SendCompleteModal from "../Model/SendCompleteModal";
import SendMemberSelectModal from "../Model/SendMemberSelectModal";
import UserProfile from "../../../Component/Normal/UserProfile";
import CheckBox from "../Model/CheckBox";
import RegistrationSettingMessageBox from "../Model/RegistrationSettingMessageBox";
import AttendanceClassSettingMessageBox from "../Model/AttendanceClassSettingMessageBox";
import ExpiredSettingMessageBox from "../Model/ExpiredSettingMessageBox";
import AutoMessageEditModal from "../Model/AutoMessageEditModal";
import HistoryContent from "../Model/HistoryContent";

import LoadingAnimation from '../../../Animation/NewLoading.json';
import DefaultProfile from '../../../image/DefaultProfile.png';
import CheckImagePath from '../../../image/Check.png';

export default function MessageSendPage() {
  const { t, languageMode } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [isSending, setIsSending] = useState(false);
  const [storeName, setStoreName] = useState('');
  const [content, setContent] = useState('');
  const [pricing, setPricing] = useState({ sms: 30, lms: 60, alimtalk: 10 });

  const [isRegistrationCard, setIsRegistrationCard] = useState(false);

  const [isHoverMemberSelectButton, setIsHoverMemberSelectButton] = useState(false);

  const [totalMembers, setTotalMembers] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);

  const [isProgress, setIsProcess] = useState(false);
  const [isClickedTotalSetting, setIsClickedTotalSetting] = useState(false);

  const [isViewRegistrationCard, setIsViewRegistrationCard] = useState(false);
  const [isViewCompleteSend, setIsViewCompleteSend] = useState(false);

  const [isViewMessageEditModal, setIsViewMessageEditModal] = useState(false);
  const [isClickedSelectedMember, setIsClickedSelectedMember] = useState(false);

  const [selectedData, setSelectedData] = useState(undefined);
  
  const [messageHistory, setMessageHistory] = useState([]);
  const [viewMessageHistory, setViewMessageHistory] = useState([]);
  const [nowPage, setNowPage] = useState(0);
  const [totalPage, setTotalPage] = useState(1);

  const [clickDivision, setClickDivision] = useState('SendMessage');
  const [rendering, setRendering] = useState(false);

  const [registration, setRegistration] = useState({
    newRegistration: {
      id: 0,
      storeId: 0,
      division: 'NewRegistration',
      isUseSetting: false,
      title: t('messageSend.editModal.descNewRegistration'),
      text: '안녕하세요. {store_name} 신규회원으로 등록하신 것을 환영합니다. 즐거운 운동시간 되세요. 감사합니다.'
    },
    reRegistration: {
      id: 0,
      storeId: 0,
      division: 'ReRegistration',
      isClicked: false,
      title: t('messageSend.editModal.descReRegistration'),
      text: '안녕하세요. {store_name}에 재등록해주신 것을 감사드립니다. 계속해서 만족을 드릴 수 있는 {store_name}이 되겠습니다. 감사합니다.'
    }
  })

  const [attendanceClass, setAttendanceClass] = useState({
    attendance: {
      id: 0,
      storeId: 0,
      division: 'Attendance',
      isUseSetting: false,
      title: t('messageSend.editModal.descAttendance'),
      text: '안녕하세요. {store_name}입니다. {user_name}님이 출석하셨습니다. 감사합니다.'
    },
    lastAttendance: {
      id: 0,
      storeId: 0,
      division: 'LastAttendance',
      isUseSetting: false,
      title: t('messageSend.editModal.descLastAttendance', { day: 0, time: 0 }),
      text: '안녕하세요. {store_name}입니다. {user_name}님, 마지막으로 방문해 운동하신지 7일이 지났습니다. 오랜만에 운동하러 나오시는 건 어떨까요? 감사합니다.',
      applyDay: 0,
      applyTime: 0
    },
    onReserve: {
      id: 0,
      storeId: 0,
      division: 'OnReserve',
      isUseSetting: false,
      title: t('messageSend.editModal.descOnReserve'),
      text: '안녕하세요. {store_name}입니다. 수업 예약이 완료되었습니다. 수업명: {class_name} 예약 시간: {reserve_time} 강사명: {coach_name} 수업 시간에 늦지 않게 참석해 주세요. 감사합니다.'
    },
    cancelReserve: {
      id: 0,
      storeId: 0,
      division: 'CancelReserve',
      isUseSetting: false,
      title: t('messageSend.editModal.descCancelReserve'),
      text: '안녕하세요. {store_name}입니다. 고객님의 예약이 취소되었습니다. 감사합니다.'
    },
    beforeReserve: {
      id: 0,
      storeId: 0,
      division: 'BeforeReserve',
      isUseSetting: false,
      title: t('messageSend.editModal.descBeforeReserve', { time: 0 }),
      text: '안녕하세요. {store_name}입니다. 예약한 수업 1시간 전입니다. 수업명: {class_name} 예약 시간: {reserve_time} 강사명: {coach_name} 수업 시간에 늦지 않게 참석해 주세요. 감사합니다.',
      applyTime: 0
    },
    absence: {
      id: 0,
      storeId: 0,
      division: 'Absence',
      isUseSetting: false,
      title: t('messageSend.editModal.descAbsence'),
      text: '안녕하세요. {store_name}입니다. 예약한 수업에 결석하셨습니다. 수업명: {class_name} 예약 시간: {reserve_time} 강사명: {coach_name} 감사합니다.'
    }
  })

  const [expired, setExpired] = useState({
    beExpiredMembership: [
      {
        id: 0,
        storeId: 0,
        division: 'BeExpiredMembership',
        isUseSetting: false,
        title: t('messageSend.editModal.descBeExpiredMembership', { day: 0, time: 0 }),
        text: '안녕하세요. {store_name}입니다. {membership_name}의 잔여일이 1일 남았습니다. 재등록 문의는 언제든지 연락 주세요. 감사합니다.',
        applyDay: 0,
        applyTime: 0
      }
    ],
    beExpiredLocker: [
      {
        id: 0,
        storeId: 0,
        division: 'BeExpiredLocker',
        isUseSetting: false,
        title: t('messageSend.editModal.descBeExpiredLocker', { day: 0, time: 0 }),
        text: '안녕하세요. {store_name}입니다. 사용중이신 락커의 잔여일이 1일 남았습니다. 만료일 전 락커를 비워주세요. 감사합니다.',
        applyDay: 0,
        applyTime: 0
      }
    ],
    expiredMembership: {
      id: 0,
      storeId: 0,
      division: 'ExpiredMembership',
      isUseSetting: false,
      title: t('messageSend.editModal.descExpiredMembership', { time: 0 }),
      text: '안녕하세요. {store_name}입니다. {membership_name}의 잔여 횟수가 1회 남았습니다. 재등록 문의는 언제든지 연락 주세요. 감사합니다.',
      applyTime: 0
    },
    hadBeenExpiredMembership: [
      {
        id: 0,
        storeId: 0,
        division: 'HadBeenExpiredMembership',
        isUseSetting: false,
        title: t('messageSend.editModal.descHadBeenExpiredMembership', { day: 0, time: 0 }),
        text: '안녕하세요. {store_name}입니다. {membership_name}이 만료되었습니다. 재등록 문의는 언제든지 연락 주세요. 감사합니다.',
        applyDay: 0,
        applyTime: 0
      }
    ],
    hadBeenExpiredLocker: [
      {
        id: 0,
        storeId: 0,
        division: 'HadBeenExpiredLocker',
        isUseSetting: false,
        title: t('messageSend.editModal.descHadBeenExpiredLocker', { day: 0, time: 0 }),
        text: '안녕하세요. {store_name}입니다. 락커의 사용기한 만료일이 1일이 지났습니다. 방문해 락커를 비워주세요. 감사합니다.',
        applyDay: 0,
        applyTime: 0
      }
    ],
    applyMembershipHolding: {
      id: 0,
      storeId: 0,
      division: 'ApplyMembershipHolding',
      isUseSetting: false,
      title: t('messageSend.editModal.descApplyMembershipHolding'),
      text: '안녕하세요. {store_name}입니다. 고객님의 홀딩신청이 정상적으로 완료되었습니다. 홀딩시작일: {holding_start_date} 홀딩종료일: {holding_end_date} 홀딩기간 중 취소를 원하시는 경우 편하게 연락 주세요. 감사합니다.',
    },
    startMembershipHolding: {
      id: 0,
      storeId: 0,
      division: 'StartMembershipHolding',
      isUseSetting: false,
      title: t('messageSend.editModal.descStartMembershipHolding', { day: 0, time: 0 }),
      text: '안녕하세요. {store_name}입니다. 홀딩중인 {membership_name}의 활성화 1일 전입니다. 홀딩시작일: {holding_start_date} 홀딩종료일: {holding_end_date} 날짜 변경을 원하시는 경우 편하게 연락 주세요. 감사합니다.',
      applyDay: 0,
      applyTime: 0
    }
  })

  // API 호출 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('message/status', 'GET');

        if (responseData.status === 200) {
          setStoreName(responseData.data.storeName);
          setIsRegistrationCard(responseData.data.isRegistrationCard);
        }
      }
    )();
  }, [])

  // 메세지 단가 조회 API //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('message/pricing', 'GET');

        if (responseData.status === 200) {
          let newPricing = { sms: 30, lms: 60, alimtalk: 10 };

          responseData.data.forEach((item) => {
            if (item.messageType === 'SMS') newPricing.sms = item.unitPrice;
            else if (item.messageType === 'LMS') newPricing.lms = item.unitPrice;
            else if (item.messageType === 'ALIMTALK') newPricing.alimtalk = item.unitPrice;
          });

          setPricing(newPricing);
        }
      }
    )();
  }, [])

  // API 호출 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('member/status_all', 'GET');
        if (responseData.status === 200) {
          let newMembers = responseData.data.slice();

          newMembers.map((data) => data.isClicked = false);

          setTotalMembers(newMembers);
        }
        else setTotalMembers([]);
      }
    )();
  }, [])

  // API 호출 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('message_setting/', 'GET');
        if (responseData.status === 200) {
          let list = responseData.data.messageSettings.slice();
          let newRegistration = lodash.cloneDeep(registration);
          let newAttendanceClass = lodash.cloneDeep(attendanceClass);
          let newExpired = lodash.cloneDeep(expired);

          list.map((data, index) => {
            if (data.division === 'NewRegistration') {
              newRegistration.newRegistration.id = data.id;
              newRegistration.newRegistration.storeId = data.storeId;
              newRegistration.newRegistration.division = 'NewRegistration';
              newRegistration.newRegistration.isUseSetting = data.isUseSetting;
              newRegistration.newRegistration.text = data.text;
              newRegistration.newRegistration.title = data.title;
            }
            else if (data.division === 'ReRegistration') {
              newRegistration.reRegistration.id = data.id;
              newRegistration.reRegistration.storeId = data.storeId;
              newRegistration.reRegistration.division = 'ReRegistration';
              newRegistration.reRegistration.isUseSetting = data.isUseSetting;
              newRegistration.reRegistration.text = data.text;
              newRegistration.reRegistration.title = data.title;
            }
            else if (data.division === 'Attendance') {
              newAttendanceClass.attendance.id = data.id;
              newAttendanceClass.attendance.storeId = data.storeId;
              newAttendanceClass.attendance.division = 'Attendance';
              newAttendanceClass.attendance.isUseSetting = data.isUseSetting;
              newAttendanceClass.attendance.text = data.text;
              newAttendanceClass.attendance.title = data.title;
            }
            else if (data.division === 'LastAttendance') {
              newAttendanceClass.lastAttendance.id = data.id;
              newAttendanceClass.lastAttendance.storeId = data.storeId;
              newAttendanceClass.lastAttendance.division = 'LastAttendance';
              newAttendanceClass.lastAttendance.isUseSetting = data.isUseSetting;
              newAttendanceClass.lastAttendance.text = data.text;
              newAttendanceClass.lastAttendance.title = data.title;
              newAttendanceClass.lastAttendance.applyDay = data.applyDay;
              newAttendanceClass.lastAttendance.applyTime = data.applyTime;
            }
            else if (data.division === 'OnReserve') {
              newAttendanceClass.onReserve.id = data.id;
              newAttendanceClass.onReserve.storeId = data.storeId;
              newAttendanceClass.onReserve.division = 'OnReserve';
              newAttendanceClass.onReserve.isUseSetting = data.isUseSetting;
              newAttendanceClass.onReserve.text = data.text;
              newAttendanceClass.onReserve.title = data.title;
            }
            else if (data.division === 'CancelReserve') {
              newAttendanceClass.cancelReserve.id = data.id;
              newAttendanceClass.cancelReserve.storeId = data.storeId;
              newAttendanceClass.cancelReserve.division = 'CancelReserve';
              newAttendanceClass.cancelReserve.isUseSetting = data.isUseSetting;
              newAttendanceClass.cancelReserve.text = data.text;
              newAttendanceClass.cancelReserve.title = data.title;
            }
            else if (data.division === 'BeforeReserve') {
              newAttendanceClass.beforeReserve.id = data.id;
              newAttendanceClass.beforeReserve.storeId = data.storeId;
              newAttendanceClass.beforeReserve.division = 'BeforeReserve';
              newAttendanceClass.beforeReserve.isUseSetting = data.isUseSetting;
              newAttendanceClass.beforeReserve.text = data.text;
              newAttendanceClass.beforeReserve.title = data.title;
              newAttendanceClass.beforeReserve.applyTime = data.applyTime;
            }
            else if (data.division === 'Absence') {
              newAttendanceClass.absence.id = data.id;
              newAttendanceClass.absence.storeId = data.storeId;
              newAttendanceClass.absence.division = 'Absence';
              newAttendanceClass.absence.isUseSetting = data.isUseSetting;
              newAttendanceClass.absence.text = data.text;
              newAttendanceClass.absence.title = data.title;
            }
            else if (data.division === 'BeExpiredMembership') {
              // 아직 데이터가 없는경우 덮어씌우기 //
              if (newExpired.beExpiredMembership[0].id === 0) {
                newExpired.beExpiredMembership[0].id = data.id;
                newExpired.beExpiredMembership[0].storeId = data.storeId;
                newExpired.beExpiredMembership[0].division = 'BeExpiredMembership';
                newExpired.beExpiredMembership[0].isUseSetting = data.isUseSetting;
                newExpired.beExpiredMembership[0].text = data.text;
                newExpired.beExpiredMembership[0].title = data.title;
                newExpired.beExpiredMembership[0].applyDay = data.applyDay;
                newExpired.beExpiredMembership[0].applyTime = data.applyTime;
              }
              // 이미 데이터가 있는경우 추가 //
              else {
                let isExist = false;

                for (let i = 0; i < newExpired.beExpiredMembership.length; i++) {
                  if (newExpired.beExpiredMembership[i].id === data.id) {
                    newExpired.beExpiredMembership[i].id = data.id;
                    newExpired.beExpiredMembership[i].storeId = data.storeId;
                    newExpired.beExpiredMembership[i].division = 'BeExpiredMembership';
                    newExpired.beExpiredMembership[i].isUseSetting = data.isUseSetting;
                    newExpired.beExpiredMembership[i].text = data.text;
                    newExpired.beExpiredMembership[i].title = data.title;
                    newExpired.beExpiredMembership[i].applyDay = data.applyDay;
                    newExpired.beExpiredMembership[i].applyTime = data.applyTime;

                    isExist = true;
                    break;
                  }
                }

                if (!isExist) {
                  let newData = {
                    id: data.id,
                    storeId: data.storeId,
                    division: 'BeExpiredMembership',
                    isUseSetting: data.isUseSetting,
                    text: data.text,
                    title: data.title,
                    applyDay: data.applyDay,
                    applyTime: data.applyTime
                  }

                  newExpired.beExpiredMembership.push(newData);
                }
              }
            }
            else if (data.division === 'BeExpiredLocker') {
              // 아직 데이터가 없는경우 덮어씌우기 //
              if (newExpired.beExpiredLocker[0].id === 0
                || newExpired.beExpiredLocker[0].id === data.id) {
                newExpired.beExpiredLocker[0].id = data.id;
                newExpired.beExpiredLocker[0].storeId = data.storeId;
                newExpired.beExpiredLocker[0].division = 'BeExpiredLocker';
                newExpired.beExpiredLocker[0].isUseSetting = data.isUseSetting;
                newExpired.beExpiredLocker[0].text = data.text;
                newExpired.beExpiredLocker[0].title = data.title;
                newExpired.beExpiredLocker[0].applyDay = data.applyDay;
                newExpired.beExpiredLocker[0].applyTime = data.applyTime;
              }
              // 이미 데이터가 있는경우 추가 //
              else {
                let isExist = false;

                for (let i = 0; i < newExpired.beExpiredLocker.length; i++) {
                  if (newExpired.beExpiredLocker[i].id === data.id) {
                    newExpired.beExpiredLocker[i].id = data.id;
                    newExpired.beExpiredLocker[i].storeId = data.storeId;
                    newExpired.beExpiredLocker[i].division = 'BeExpiredLocker';
                    newExpired.beExpiredLocker[i].isUseSetting = data.isUseSetting;
                    newExpired.beExpiredLocker[i].text = data.text;
                    newExpired.beExpiredLocker[i].title = data.title;
                    newExpired.beExpiredLocker[i].applyDay = data.applyDay;
                    newExpired.beExpiredLocker[i].applyTime = data.applyTime;

                    isExist = true;
                    break;
                  }
                }

                if (!isExist) {
                  let newData = {
                    id: data.id,
                    storeId: data.storeId,
                    division: 'BeExpiredLocker',
                    isUseSetting: data.isUseSetting,
                    text: data.text,
                    title: data.title,
                    applyDay: data.applyDay,
                    applyTime: data.applyTime
                  }

                  newExpired.beExpiredLocker.push(newData);
                }
              }
            }
            else if (data.division === 'ExpiredMembership') {
              newExpired.expiredMembership.id = data.id;
              newExpired.expiredMembership.storeId = data.storeId;
              newExpired.expiredMembership.division = 'ExpiredMembership';
              newExpired.expiredMembership.isUseSetting = data.isUseSetting;
              newExpired.expiredMembership.text = data.text;
              newExpired.expiredMembership.title = data.title;
              newExpired.expiredMembership.applyDay = data.applyDay;
              newExpired.expiredMembership.applyTime = data.applyTime;
            }
            else if (data.division === 'HadBeenExpiredMembership') {
              // 아직 데이터가 없는경우 덮어씌우기 //
              if (newExpired.hadBeenExpiredMembership[0].id === 0
                || newExpired.hadBeenExpiredMembership[0].id === data.id) {
                newExpired.hadBeenExpiredMembership[0].id = data.id;
                newExpired.hadBeenExpiredMembership[0].storeId = data.storeId;
                newExpired.hadBeenExpiredMembership[0].division = 'HadBeenExpiredMembership';
                newExpired.hadBeenExpiredMembership[0].isUseSetting = data.isUseSetting;
                newExpired.hadBeenExpiredMembership[0].text = data.text;
                newExpired.hadBeenExpiredMembership[0].title = data.title;
                newExpired.hadBeenExpiredMembership[0].applyDay = data.applyDay;
                newExpired.hadBeenExpiredMembership[0].applyTime = data.applyTime;
              }
              // 이미 데이터가 있는경우 추가 //
              else {
                let isExist = false;

                for (let i = 0; i < newExpired.hadBeenExpiredMembership.length; i++) {
                  if (newExpired.hadBeenExpiredMembership[i].id === data.id) {
                    newExpired.hadBeenExpiredMembership[i].id = data.id;
                    newExpired.hadBeenExpiredMembership[i].storeId = data.storeId;
                    newExpired.hadBeenExpiredMembership[i].division = 'HadBeenExpiredMembership';
                    newExpired.hadBeenExpiredMembership[i].isUseSetting = data.isUseSetting;
                    newExpired.hadBeenExpiredMembership[i].text = data.text;
                    newExpired.hadBeenExpiredMembership[i].title = data.title;
                    newExpired.hadBeenExpiredMembership[i].applyDay = data.applyDay;
                    newExpired.hadBeenExpiredMembership[i].applyTime = data.applyTime;

                    isExist = true;
                    break;
                  }
                }

                if (!isExist) {
                  let newData = {
                    id: data.id,
                    storeId: data.storeId,
                    division: 'HadBeenExpiredMembership',
                    isUseSetting: data.isUseSetting,
                    text: data.text,
                    title: data.title,
                    applyDay: data.applyDay,
                    applyTime: data.applyTime
                  }

                  newExpired.hadBeenExpiredMembership.push(newData);
                }
              }
            }
            else if (data.division === 'HadBeenExpiredLocker') {
              // 아직 데이터가 없는경우 덮어씌우기 //
              if (newExpired.hadBeenExpiredLocker[0].id === 0
                || newExpired.hadBeenExpiredLocker[0].id === data.id) {
                newExpired.hadBeenExpiredLocker[0].id = data.id;
                newExpired.hadBeenExpiredLocker[0].storeId = data.storeId;
                newExpired.hadBeenExpiredLocker[0].division = 'HadBeenExpiredLocker';
                newExpired.hadBeenExpiredLocker[0].isUseSetting = data.isUseSetting;
                newExpired.hadBeenExpiredLocker[0].text = data.text;
                newExpired.hadBeenExpiredLocker[0].title = data.title;
                newExpired.hadBeenExpiredLocker[0].applyDay = data.applyDay;
                newExpired.hadBeenExpiredLocker[0].applyTime = data.applyTime;
              }
              // 이미 데이터가 있는경우 추가 //
              else {
                let isExist = false;

                for (let i = 0; i < newExpired.hadBeenExpiredLocker.length; i++) {
                  if (newExpired.hadBeenExpiredLocker[i].id === data.id) {
                    newExpired.hadBeenExpiredLocker[i].id = data.id;
                    newExpired.hadBeenExpiredLocker[i].storeId = data.storeId;
                    newExpired.hadBeenExpiredLocker[i].division = 'HadBeenExpiredLocker';
                    newExpired.hadBeenExpiredLocker[i].isUseSetting = data.isUseSetting;
                    newExpired.hadBeenExpiredLocker[i].text = data.text;
                    newExpired.hadBeenExpiredLocker[i].title = data.title;
                    newExpired.hadBeenExpiredLocker[i].applyDay = data.applyDay;
                    newExpired.hadBeenExpiredLocker[i].applyTime = data.applyTime;

                    isExist = true;
                    break;
                  }
                }

                if (!isExist) {
                  let newData = {
                    id: data.id,
                    storeId: data.storeId,
                    division: 'HadBeenExpiredLocker',
                    isUseSetting: data.isUseSetting,
                    text: data.text,
                    title: data.title,
                    applyDay: data.applyDay,
                    applyTime: data.applyTime
                  }

                  newExpired.hadBeenExpiredLocker.push(newData);
                }
              }
            }
            else if (data.division === 'ApplyMembershipHolding') {
              newExpired.applyMembershipHolding.id = data.id;
              newExpired.applyMembershipHolding.storeId = data.storeId;
              newExpired.applyMembershipHolding.division = 'ApplyMembershipHolding';
              newExpired.applyMembershipHolding.isUseSetting = data.isUseSetting;
              newExpired.applyMembershipHolding.text = data.text;
              newExpired.applyMembershipHolding.title = data.title;
            }
            else if (data.division === 'StartMembershipHolding') {
              newExpired.startMembershipHolding.id = data.id;
              newExpired.startMembershipHolding.storeId = data.storeId;
              newExpired.startMembershipHolding.division = 'StartMembershipHolding';
              newExpired.startMembershipHolding.isUseSetting = data.isUseSetting;
              newExpired.startMembershipHolding.text = data.text;
              newExpired.startMembershipHolding.title = data.title;
              newExpired.startMembershipHolding.applyDay = data.applyDay;
              newExpired.startMembershipHolding.applyTime = data.applyTime;
            }
          });

          setIsClickedTotalSetting(responseData.data.isUseAutoMessageSetting);
          setRegistration(newRegistration);
          setAttendanceClass(newAttendanceClass);
          setExpired(newExpired);
        }
      }
    )();
  }, [rendering])


  // API 호출 //
  useEffect(() => {
    if (clickDivision === 'MessageHistory') {
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.getDataVersion2('message_setting/history', 'GET');
          if (responseData.status === 200) {
            setMessageHistory(responseData.data);
            setTotalPage(Math.ceil(responseData.data.length/10));
            setNowPage(0);
          }
          else {
            setMessageHistory([]);
            setTotalPage(1);
            setNowPage(0);
          }
        }
      )();
    }
  }, [clickDivision])

  useEffect(() => {
    setViewMessageHistory(messageHistory.slice((nowPage * 10), (nowPage * 10) + 10));
  }, [messageHistory, nowPage])


  // UTF-8 바이트 계산 //
  function checkValueByte(str) {
    let byteLength = 0;
    for (let i = 0, strLength = str.length; i < strLength; i++) {
      let code = str.charCodeAt(i);
      if (code < 0x0080) byteLength += 1;
      else if (code < 0x0800) byteLength += 2;
      else if (code < 0xD800) byteLength += 3;
      else if (code < 0xDC00) {
        let codeNext = str.charCodeAt(++i);
        if (i < strLength && codeNext >= 0xDC00 && codeNext <= 0xDFFF) byteLength += 4;
      }
      else if (code >= 0xE000) byteLength += 3;
    }
    return byteLength;
  }

  // 메시지 단가 계산 (SMS/LMS 자동 판별) //
  function getUnitPrice() {
    return checkValueByte(content) < 90 ? pricing.sms : pricing.lms;
  }

  // 회원수 계산 //
  function decideMemberCount() {
    return t('messageSend.sendCountInfo', { count: selectedMembers.length.toLocaleString('ko-KR') });
  }

  // 결제 금액 //
  function decideCalcPrice() {
    let total = getUnitPrice() * selectedMembers.length;
    return t('messageSend.sendPrice', { price: total.toLocaleString('ko-KR') });
  }

  // 완료모달 텍스트 결정 //
  function decideCompleteMemberCount() {
    return t('messageSend.completeMemberCount', { count: selectedMembers.length.toLocaleString('ko-KR') });
  }

  // 회원 선택 추가 모달에서 회원추가 버튼 클릭시 //
  function onClickAdditionButton(selectedMembers) {
    let newTotalMembers = totalMembers.slice();
    let members = lodash.cloneDeep(selectedMembers);

    newTotalMembers.map((data) => data.isClicked = false);
    members.map((data) => data.isClicked = false);

    setTotalMembers(newTotalMembers);
    setSelectedMembers(members);
    setIsClickedSelectedMember(false);
  }

  // 전송회원 체크박스 선택시 //
  function onClickMemberInfo(data) {
    let newSelectedMembers = selectedMembers.slice();
    let index = newSelectedMembers.findIndex(item => item.memberId === data.memberId);

    newSelectedMembers[index].isClicked = !newSelectedMembers[index].isClicked;

    setSelectedMembers(newSelectedMembers);
  }

  // 선택삭제 버튼 클릭시 //
  function onClickSelectedDelete() {
    let newSelectedMembers = selectedMembers.slice();
    let saveMembers = [];

    newSelectedMembers.map((data) => {
      if (!data.isClicked) saveMembers.push(data);
    })

    setSelectedMembers(saveMembers);
  }

  // 전체삭제 버튼 클릭시 //
  function onClickAllDelete() {
    let newMembers = totalMembers.slice();

    newMembers.map((data) => data.isClicked = false);

    setTotalMembers(newMembers);
    setSelectedMembers([]);
  }

  // 회원목록에서 불러오기 //
  function onClickMemberLoading() {
    let newTotalMembers = totalMembers.slice();
    let newSelectedMembers = selectedMembers.slice();

    newTotalMembers.map((data) => data.isClicked = false);

    for (let i = 0; i < newSelectedMembers.length; i++) {
      for (let j = 0; j < newTotalMembers.length; j++) {
        if (newSelectedMembers[i].memberId === newTotalMembers[j].memberId) {
          newTotalMembers[j].isClicked = true;
          break;
        }
      }
    }

    setTotalMembers(newTotalMembers);
    setIsClickedSelectedMember(true);
  }

  // 입력하기 버튼 클릭시 //
  function onClickRegistrationCard() {
    const obj = {};

    obj.PCD_PAY_TYPE = 'card'
    obj.PCD_PAY_WORK = 'AUTH'
    obj.PCD_CARD_VER = '01';
    obj.PCD_PAYER_AUTHTYPE = 'sms';

    obj.callbackFunction = getResult;
    obj.clientKey = '0F44C92BFB07F1BE60C5235A7254316D';

    window.PaypleCpayAuthCheck(obj);
  }

  // 결제 이후 콜백 //
  function getResult(res) {
    if (res.PCD_PAY_RST === 'success' && (res.PCD_PAY_CODE === '0000' || res.PCD_PAY_CODE === 'CDAU1000')) {
      let requestData = {
        billingKey: res.PCD_PAYER_ID,
        cardName: res.PCD_PAY_CARDNAME,
        cardNum: res.PCD_PAY_CARDNUM
      }
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('billing/registry', 'POST', requestData);

          if (responseData.status === 200) {
            alert(t('messageSend.alertCardRegistered'));
            setIsRegistrationCard(true);
            setIsViewRegistrationCard(false);
          }
          else if (responseData.status === 201) {
            alert(t('messageSend.alertAlreadyRegistered'));
            setIsViewRegistrationCard(false);
          }
        }
      )();
    }
    else {
      if (res.PCD_PAY_CODE === undefined) {
        alert(res.PCD_PAY_MSG);
      }
      else {
        alert('[' + res.PCD_PAY_CODE + ']' + ' ' + res.PCD_PAY_MSG);
      }
    }
  }

  // 메시지 보내기 버튼 클릭시 //
  function onClickSendMessage() {
    let memberIds = [];

    selectedMembers.map((data) => {
      memberIds.push(data.memberId);
    })

    if (memberIds.length === 0) {
      alert(t('messageSend.alertNoMembers'));
      return;
    }
    else if (content === '') {
      alert(t('messageSend.alertEnterContent'));
      return;
    }

    if (isRegistrationCard) {
      if (isSending) {
        alert(t('messageSend.alertSending'));
        return;
      }

      setIsSending(true);

      let requestData = {
        title: storeName,
        content: content,
        memberIds: memberIds
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('message/send_target', 'POST', requestData);

          if (responseData.status === 200) {
            setTimeout(() => {
              setIsViewCompleteSend(true);
              setIsSending(false);
              setContent('');
            }, 600)
          }
          else {
            alert(t('messageSend.alertSendFailed'));
            setIsSending(false);
          }
        }
      )();

    }
    else setIsViewRegistrationCard(true);
  }

  // 자동메세지 사용 버튼 전환시 //
  function onClickUseSettingBox() {
    if (isProgress) {
      alert(t('messageSend.alertSaving'));
      return;
    }

    setIsProcess(true);

    let requestData = {
      isUseAutoMessage: !isClickedTotalSetting
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('message_setting/switch', 'POST', requestData);

        if (responseData.status === 200) {
          setIsClickedTotalSetting(!isClickedTotalSetting);
          setIsProcess(false);
        }
        else {
          setIsProcess(false);
        }
      }
    )();

  }

  // 수정하기 버튼 클릭시 //
  function onClickEditText(data) {
    let newData = lodash.cloneDeep(data);

    setSelectedData(newData);
    setIsViewMessageEditModal(true);
  }

  // 자동메세지 수정모달 취소버튼 클릭시 //
  function onClickExitInEditModal() {
    setSelectedData(undefined);
    setIsViewMessageEditModal(false);
  }

  // 자동메세지 수정모달 저장 버튼 클릭시 //
  function onClickSave(data) {
    if (isProgress) {
      alert(t('messageSend.alertSavingInProgress'));
      return;
    }

    setIsProcess(true);

    let requestData = {
      id: selectedData.id,
      storeId: selectedData.storeId,
      division: selectedData.division,
      text: data,
      title: selectedData.title,
      applyDay: selectedData.applyDay,
      applyTime: selectedData.applyTime,
      isUseSetting: selectedData.isUseSetting
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('message_setting/save', 'POST', requestData);

        if (responseData.status === 200) {
          setRendering(!rendering);
          setIsViewMessageEditModal(false);
          setIsProcess(false);
        }
      }
    )();
  }

  // 이전 페이지 클릭시 //
  function onClickPrev() {
    if (nowPage > 0) setNowPage(nowPage - 1);
  }

  // 다음 페이지 클릭시 //
  function onClickNext() {
    if (nowPage < totalPage - 1) setNowPage(nowPage + 1);
  }

  return (
    <TopLevelWrapper>
      {isViewCompleteSend && <SendCompleteModal text={decideCompleteMemberCount()} onClickExit={() => setIsViewCompleteSend(false)} />}
      {isViewRegistrationCard && <NotRegistrationCardModal division='Notice' setIsViewModal={setIsViewRegistrationCard} onClickRegistCard={onClickRegistrationCard} />}
      {isClickedSelectedMember && <SendMemberSelectModal memberList={totalMembers} onClickAdditionButton={onClickAdditionButton} onClickExit={() => setIsClickedSelectedMember(false)} />}
      {isViewMessageEditModal && <AutoMessageEditModal data={selectedData} onClickExit={onClickExitInEditModal} onClickSave={onClickSave} />}
      <TitleBar>
        <TextWrapper>
          <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} hover='default'>{t('messageSend.title')}</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} hover='default'>{t('messageSend.description')}</Text>
        </TextWrapper>
        {/* <SendButton onClick={onClickSendMessage}>문자 전송</SendButton> */}
      </TitleBar>
      <ColumnWrapper>
        <ColumnButton isClicked={clickDivision === 'SendMessage'} onClick={() => setClickDivision('SendMessage')}>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={clickDivision === 'SendMessage' ? theme.subBackground : theme.subText} hover='pointer'>{t('messageSend.tabSend')}</Text>
        </ColumnButton>
        <ColumnButton isClicked={clickDivision === 'SettingAutoMessage'} onClick={() => setClickDivision('SettingAutoMessage')}>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={clickDivision === 'SettingAutoMessage' ? theme.subBackground : theme.subText} hover='pointer'>{t('messageSend.tabAutoMessage')}</Text>
        </ColumnButton>
        <ColumnButton isClicked={clickDivision === 'MessageHistory'} onClick={() => setClickDivision('MessageHistory')}>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={clickDivision === 'MessageHistory' ? theme.subBackground : theme.subText} hover='pointer'>{t('messageSend.tabHistory')}</Text>
        </ColumnButton>
      </ColumnWrapper>
      {
        clickDivision === 'SendMessage' &&
        <MessageBoxWrapper>
          {
            isSending &&
            <LoadingView>
              <LottieWrapper>
                <Lottie animationData={LoadingAnimation} loop={true} />
              </LottieWrapper>
            </LoadingView>
          }
          <MessageBox>
            <WriteCommponentWrapper style={{ marginTop: '28px' }}>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} hover='default'>{t('messageSend.titleLabel')}</Text>
              <TitleInputView>
                <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.subText} hover='default'>{storeName}</Text>
              </TitleInputView>
            </WriteCommponentWrapper>
            <WriteCommponentWrapper style={{ marginTop: '28px', marginBottom: '28px' }}>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} hover='default'>{t('messageSend.contentLabel')}</Text>
              <ContentInput
                value={content}
                setValue={setContent}
                placeholder={t('messageSend.contentPlaceholder')} />
            </WriteCommponentWrapper>
            {/* <MessageSettingWrapper>
                <SettingInnerWrapper>
                  <TotalCheckBoxWrapper>
                    <CheckBoxWrapper onClick={() => setIsClickedValid(!isClickedValid)}>
                      <CheckBox isClicked={isClickedValid} />
                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='pointer'>유효 회원</Text>
                    </CheckBoxWrapper>
                    <CheckBoxWrapper onClick={() => setIsClickedInvalid(!isClickedInvalid)}>
                      <CheckBox isClicked={isClickedInvalid} />
                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='pointer'>만료 회원</Text>
                    </CheckBoxWrapper>
                  </TotalCheckBoxWrapper>
                  <SettingTextWrapper>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{decideMemberCount() + ' 명 회원에게 문자 메시지 발송시'}</Text>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000' hover='default'>{decideCalcPrice() + '원'}</Text>
                  </SettingTextWrapper>
                </SettingInnerWrapper>
              </MessageSettingWrapper> */}
          </MessageBox>
          {/* <MockUpWrapper>
              <MockUp src={MockUpImage}/>
              <MockUpComponent>
                <MockUpComponentInnerWrapper>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={10} color='#A4A4A4' hover='default'>단말기 설정에 따라 다르게 보일 수 있습니다</Text>
                  <MockUpTitleBox>
                    <Text fontFamily='NotoSansKR-Bold' fontSize={12} color='#000000' hover='default'>{storeName}</Text>
                  </MockUpTitleBox>
                  <MockUpContentBox>
                    <PreText fontFamily='NotoSansKR-Medium' fontSize={12} color='#000000' hover='default'>{content}</PreText>
                  </MockUpContentBox>
                </MockUpComponentInnerWrapper>
              </MockUpComponent>
            </MockUpWrapper> */}
          <MemberSelectBoxWrapper>
            <MemberFindButton
              isHover={isHoverMemberSelectButton} 
              onMouseOver={() => setIsHoverMemberSelectButton(true)}
              onMouseLeave={() => setIsHoverMemberSelectButton(false)}
              onClick={onClickMemberLoading}>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={isHoverMemberSelectButton ? theme.subBackground : theme.subKey} hover='pointer'>{t('messageSend.loadFromMemberList')}</Text>
            </MemberFindButton>
            {
              selectedMembers.length === 0 ?
                <NoneSelectedBox>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} hover='default'>{t('messageSend.noSelectedMembers')}</Text>
                </NoneSelectedBox>
                :
                <MemberSelectBox>
                  <MemberSelectBoxButtonWrapper>
                    <DeleteButton onClick={onClickSelectedDelete}>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} hover='pointer'>{t('messageSend.deleteSelected')}</Text>
                    </DeleteButton>
                    <DeleteButton onClick={onClickAllDelete}>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} hover='pointer'>{t('messageSend.deleteAll')}</Text>
                    </DeleteButton>
                  </MemberSelectBoxButtonWrapper>
                  <SelectedMemberBox>
                    <SelectedMemberInfoWrapper height={37 * selectedMembers.length}>
                      {
                        selectedMembers.map((data, index) => (
                          <SelectedMemberInfo key={'FinalSelectedMember-' + index}>
                            <ProfileWrapper isFirst={index === 0} isLast={selectedMembers.length - 1 === index}>
                              <UserProfile profile={data.profile} defaultProfile={DefaultProfile} />
                            </ProfileWrapper>
                            <SelectedMemberTextWrapper marginLeft={10} width={45}>
                              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} hover='default'>{data.name}</Text>
                            </SelectedMemberTextWrapper>
                            <SelectedMemberTextWrapper marginLeft={4} width={98}>
                              <Text style={{ width: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} hover='default'>{formatPhoneNumber(data.phone, data.countryCode, languageMode) || t('messageSend.noPhone')}</Text>
                            </SelectedMemberTextWrapper>
                            <MemberCheckBox isClicked={data.isClicked} onClick={() => onClickMemberInfo(data)}>
                              {
                                data.isClicked && <CheckImage src={CheckImagePath} />
                              }
                            </MemberCheckBox>
                          </SelectedMemberInfo>
                        ))
                      }
                    </SelectedMemberInfoWrapper>
                  </SelectedMemberBox>
                  <SettingTextWrapper>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} hover='default'>{decideMemberCount()}</Text>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='default'>{decideCalcPrice()}</Text>
                  </SettingTextWrapper>
                  <SendMessageButton onClick={onClickSendMessage}>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} hover='pointer'>{t('messageSend.sendMessage')}</Text>
                  </SendMessageButton>
                </MemberSelectBox>
            }
          </MemberSelectBoxWrapper>
        </MessageBoxWrapper>
      }
      {
        clickDivision === 'SettingAutoMessage' &&
        <MessageBoxWrapper style={{ flexDirection: 'column', marginLeft: '28px', width: '1001px' }}>
          <TotalUseSettingWrapper>
            <TotalUseSettingBox
              isClicked={isClickedTotalSetting}
              onClick={onClickUseSettingBox}>
              <CheckBox
                isClicked={isClickedTotalSetting}
                onClickCheckBox={onClickUseSettingBox}

                boxWidth={15}
                boxHeight={15}
                boxRadius={5}

                imageWidth={10}
                imageHeight={7} />
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={isClickedTotalSetting ? theme.primary : theme.text} hover='pointer'>{t('messageSend.autoMessage.useSettingLabel')}</Text>
            </TotalUseSettingBox>
            <TotalUseTextWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={10} color={theme.subText} hover='default'>{t('messageSend.autoMessage.useSettingDesc1')}</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={10} color={theme.subText} hover='default'>{t('messageSend.autoMessage.useSettingDesc2')}</Text>
            </TotalUseTextWrapper>
          </TotalUseSettingWrapper>
          <DivisionSettingBoxWrapper>
            <RegistrationSettingMessageBox
              isActivate={isClickedTotalSetting}
              registration={registration}
              setRegistration={setRegistration}
              onClickEdit={onClickEditText} />

            <AttendanceClassSettingMessageBox
              isActivate={isClickedTotalSetting}
              attendanceClass={attendanceClass}
              setAttendanceClass={setAttendanceClass}
              onClickEdit={onClickEditText} />

            <ExpiredSettingMessageBox
              isActivate={isClickedTotalSetting}
              expired={expired}
              setExpired={setExpired}
              onClickEdit={onClickEditText} />
          </DivisionSettingBoxWrapper>
        </MessageBoxWrapper>
      }
      {
        clickDivision === 'MessageHistory' &&
        // <MessageBoxWrapper style={{ flexDirection: 'column', marginLeft: '28px', width: '1025px', gap: '0px' }}>
        <MessageBoxWrapper style={{ flexDirection: 'column', marginLeft: '28px', width: '1001px', gap: '0px' }}>
          <HistoryColumnWrapper>
            <HistoryTextWrapper width={93}>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='default'>{t('messageSend.history.sendTime')}</Text>
            </HistoryTextWrapper>
            <DivisionLine backgroundColor='rgba(150, 150, 150, 0.5)'/>
            <HistoryTextWrapper width={60}>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='default'>{t('messageSend.history.division')}</Text>
            </HistoryTextWrapper>
            <DivisionLine backgroundColor='rgba(150, 150, 150, 0.5)'/>
            <HistoryTextWrapper width={611}>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='default'>{t('messageSend.history.content')}</Text>
            </HistoryTextWrapper>
            <DivisionLine backgroundColor='rgba(150, 150, 150, 0.5)'/>
            <HistoryTextWrapper width={52}>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='default'>{t('messageSend.history.sendCount')}</Text>
            </HistoryTextWrapper>
            <DivisionLine backgroundColor='rgba(150, 150, 150, 0.5)'/>
            <HistoryTextWrapper width={44}>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='default'>{t('messageSend.history.success')}</Text>
            </HistoryTextWrapper>
            <DivisionLine backgroundColor='rgba(150, 150, 150, 0.5)'/>
            <HistoryTextWrapper width={44}>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='default'>{t('messageSend.history.failed')}</Text>
            </HistoryTextWrapper>
          </HistoryColumnWrapper>
          {
            viewMessageHistory.length === 0 ? 
                <HistoryTotalWrapper style={{ justifyContent: 'center' }}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.line} hover='default'>{t('messageSend.history.noHistory')}</Text>
                </HistoryTotalWrapper>
                :
                <HistoryTotalWrapper>
                  {
                    viewMessageHistory.map((data, index) => (
                      <HistoryContentWrapper key={'MessageHistory-' + index}>
                        <HistoryContent index={index} data={data} />
                      </HistoryContentWrapper>
                    ))
                  }
                </HistoryTotalWrapper>
          }
          <PaginationTotalWrapper>
            <PaginationWrapper>
              <PaginationButtonWrapper onClick={onClickPrev}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={nowPage === 0 ? theme.line : theme.text} hover='pointer'>{t('messageSend.history.prev')}</Text>
              </PaginationButtonWrapper>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} hover='default'>{nowPage + 1}/{totalPage === 0 ? 1 : totalPage}</Text>
              <PaginationButtonWrapper onClick={onClickNext}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={nowPage === totalPage - 1 ? theme.line : theme.text} hover='pointer'>{t('messageSend.history.next')}</Text>
              </PaginationButtonWrapper>
            </PaginationWrapper>
          </PaginationTotalWrapper>
        </MessageBoxWrapper>
      }
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
  
  margin: 0px 0px 252px 20px;

  width: 100%;
`;

const TitleBar = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 992px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
`;

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin: 20px 0px 0px 0px;
  gap: 10px;
`;

const ColumnButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0px 20px;

  height: 30px;

  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.subBackground}`};
  border-radius: 10px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const MessageBoxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 16px;

  width: 1029px;
`;

const MessageBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  margin-top: 28px;

  width: 627px;

  border-radius: 30px;
  background-color: ${props => props.theme.subBackground};
`;

const LoadingView = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  margin-top: 28px;

  justify-content: center;
  align-items: center;

  width: 627px;
  height: 526px;
  
  border-radius: 30px;
  background-color: ${props => props.theme.subBackground};
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 160px;
  height: 160px;
`;

const WriteCommponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 90.33%;

  gap: 8px;
`;

const TitleInputView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 8px 0px 8px;

  width: calc(100% - 18px);
  height: 30px;

  overflow: hidden;

  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};
`;

const SettingTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;
  
  padding: 0px 10px;
  margin-top: 16px;

  gap: 4px;

  width: calc(100% - 20px);
`;

const MemberSelectBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 30px;

  width: 386px;
`;

const MemberFindButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: calc(100% - 2px);
  height: 41px;

  border: 1px solid ${props => props.theme.subKey};
  border-radius: 10px;
  background-color: ${props => props.isHover ? props.theme.subKey : props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const MemberSelectBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 10px;

  width: 100%;
`;

const MemberSelectBoxButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  padding: 0px 10px;

  width: calc(100% - 20px);

  gap: 10px;
`;

const NoneSelectedBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 10px;

  width: calc(100% - 2px);
  height: 77px;

  border: 1px solid ${props => props.theme.buttonFill};
  border-radius: 10px;
  background-color: ${props => props.theme.buttonFill};
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 8px;
  height: 22px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  background-color: ${props => props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const SelectedMemberBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 13px;

  width: 100%;
  height: 333px;

  overflow-x: hidden;
  overflow-y: scroll;

	&::-webkit-scrollbar {
		width: 9px;
	}

	&::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px ${props => props.theme.scrollBar};
		border: 3px solid transparent;
		height: 25px;
		border-radius: 200px;
	}

	&::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
		border: 4px solid transparent;
		background-color: transparent;
	}

	&::-webkit-scrollbar-track-piece {
		background-color: transparent;
	}
`;

const SelectedMemberInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  border-radius: 4px;
  background-color: ${props => props.theme.subBackground};
`;

const SelectedMemberInfo = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: 37px;
`;

const ProfileWrapper = styled.div`
  width: 37px;
  height: 37px;

  border-top-left-radius: ${props => props.isFirst ? `4px` : `0px`};
  border-bottom-left-radius: ${props => props.isLast ? `4px` : `0px`};

  overflow: hidden;

  img {
    object-fit: cover;
    object-position: center;
  }
`;

const SelectedMemberTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-left: ${props => props.marginLeft}px;

  width: ${props => props.width}px;
  height: 20px;

  overflow: hidden;
`;

const MemberCheckBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-left: 156px;

  width: 16px;
  height: 16px;

  border: ${props => props.isClicked ? `1px solid ${props.theme.subKey}` : `1px solid ${props.theme.line}`};
  border-radius: 2px;
  background-color: ${props => props.isClicked ? props.theme.subKey : props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const SendMessageButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 16px;

  width: 100%;
  height: 43px;

  border-radius: 10px;
  background-color: ${props => props.theme.subKey};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const CheckImage = styled.img`
  width: 10px;
  height: 8px;
`;

const TotalUseSettingWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 20px;

  gap: 10px;
`;

const TotalUseSettingBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;
  
  padding: 0px 10px;

  height: 50px;

  gap: 10px;

  border-radius: 10px;
  background-color: ${props => props.isClicked ? `${props.theme.primaryAlpha20}` : `${props.theme.subBackground}`};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const TotalUseTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;
`;

const DivisionSettingBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 30px;
`;

const HistoryColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  margin-top: 20px;

  width: 100%;
  height: 31px;

  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: ${props => props.theme.buttonFill};
`;

const HistoryTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 0px 8px;

  width: ${props => props.width}px;
`;

const DivisionLine = styled.div`
  width: 1px;
  height: 100%;

  background-color: ${props => props.backgroundColor};
`;

const HistoryTotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  min-height: 100px;

  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  background-color: ${props => props.theme.subBackground};
`;

const HistoryContentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
`;

const PaginationTotalWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 22px;

  width: 100%;
`;

const PaginationWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 12px;
`;

const PaginationButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.hover};
    }
  }

  transition: all 0.3s ease-in-out;
`;
